/**
 * Thin navigation seam for the PMS Shell v4.
 *
 * Mirrors `widgets/admin-shell/navigate.ts`. The sign-out flow needs to
 * leave the React tree entirely — the cleanest way in this app is a hard
 * `window.location.assign(...)`, the same pattern `LoginPage` uses for the
 * post-login transition. Wrapping the call in a standalone module gives
 * tests a single mock surface (`vi.mock('../navigate.js')`), because
 * `Location.assign` is non-configurable in JSDOM 25 and direct `vi.spyOn`
 * fails.
 *
 * Per-widget seam (not a single `shared/` helper) on purpose: it matches
 * the admin shell's existing copy and keeps the `vi.mock` surface local to
 * each shell's spec — the established idiom in this codebase.
 *
 * Keep this file deliberately tiny: one exported function per destination.
 * Routing logic here would re-introduce the test coupling we're avoiding.
 */

/**
 * Send the user to /login. Used by the PMS account-menu sign-out flow after
 * the backend logout call + `queryClient.clear()` — the hard navigation
 * guarantees no stale React state survives.
 */
export function navigateToLogin(): void {
  if (typeof window === 'undefined') return;
  window.location.assign('/login');
}
